export enum ActionType {
  REMOVE = 'REMOVE',
  VARIANT = 'VARIANT',
}

export enum DispositionStockStatusEnum {
  TNA = 'TNA',
  NLA = 'NLA',
  ship = 'ship',
  NYA = 'NYA',
}

export enum Dispositionlabels {
  TNA = 'product.StockStatus.outOfStock',
  OUT_OF_STOCK = 'product.StockStatus.outOfStock',
  NLA = 'product.StockStatus.noLongerAvailable',
  NYA = 'product.StockStatus.notYetAvailable',
  CHANGE_VARIANT = 'product.dispositionStockStatus.changeVariant',
  REMOVE = 'product.dispositionStockStatus.remove',
  CHANGE = 'product.dispositionStockStatus.change',
  CHECKOUTINVENTORY = 'product.dispositionStockStatus.checkoutInventory',
  NONE = ' ',
}
